// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DashboardCourseCard_wrapper__W2I8n","content":"DashboardCourseCard_content__UqGsk","progress-wrapper":"DashboardCourseCard_progress-wrapper__GjLC4"};